import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonFooter,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonSpinner
} from '@ionic/react';
import { secondsToTime } from 'src/lib/time';
import EstimateGauge from 'src/components/EstimateGauge';
import FieldEstimate from 'src/components/FieldEstimate';
import StageBar from 'src/components/StageBar';
import Subscribe from 'src/components/Subscribe';
import alerts from 'src/lib/alerts';
import './style.scss';

class StageWork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      new_estimate: this.props.stage.original_estimate
    };
    this.gaugeWidth = window.innerWidth - 60;
    const minGaugeHeight = 165;
    // 323 = combined height of everyting on page except gauge
    const desiredGaugeHeight = window.innerHeight - 323;
    this.gaugeHeight =
      desiredGaugeHeight <= minGaugeHeight
        ? minGaugeHeight
        : desiredGaugeHeight;
  }

  handleNewEstimateChange = ({ target }) => {
    this.setState({ new_estimate: target.value });
  };

  handleNewEstimateSubmit = async () => {
    const { new_estimate } = this.state;
    await this.props
      .updateStage({ adjusted_estimate: new_estimate })
      .catch(alerts.errors);
  };

  handleStageEnd = () => {
    this.props.nextStage().catch(alerts.errors);
  };

  render() {
    const { adjusted_estimate, original_estimate } = this.props.stage;
    const {
      timePassed,
      fetching,
      job,
      stageContainer,
      stage,
      startBreak,
      endBreak
    } = this.props;
    const { new_estimate } = this.state;
    return (
      <React.Fragment>
        <IonContent id="StageWork">
          <StageBar
            job={job}
            stage={stage}
            stageContainer={stageContainer}
            onStartBreak={startBreak}
            onEndBreak={endBreak}
            fetching={fetching}
          />
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Original Estimate:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              <strong>{secondsToTime(original_estimate)}</strong>
            </IonCol>
          </IonRow>
          <IonRow
            className="px-1 py-2"
            style={{ borderBottom: '1px solid #ededed' }}
          >
            <IonCol>Your Estimate:</IonCol>
            <IonCol size="auto" className="ion-text-right">
              <strong>
                {secondsToTime(adjusted_estimate || original_estimate)}
              </strong>
            </IonCol>
          </IonRow>
          <IonGrid>
            {adjusted_estimate && (
              <IonRow>
                <IonCol size="12">
                  <EstimateGauge
                    max={Math.ceil(adjusted_estimate, original_estimate)}
                    label={secondsToTime(timePassed)}
                    value={timePassed}
                    width={this.gaugeWidth}
                    height={this.gaugeHeight}
                    adjustedEstimate={adjusted_estimate}
                    originalEstimate={original_estimate}
                  />
                </IonCol>
              </IonRow>
            )}
            {!adjusted_estimate && (
              <IonRow className="p-5">
                <div className="ion-text-center">
                  <h4>Your Estimate</h4>
                  <p className="lead">
                    If you have arrived on site and believe that the original
                    estimate may be incorrect, you can change it here.
                  </p>
                  <div className="form-group">
                    <FieldEstimate
                      value={new_estimate}
                      onChange={this.handleNewEstimateChange}
                    />
                  </div>
                </div>
              </IonRow>
            )}
          </IonGrid>
        </IonContent>
        <IonFooter>
          <IonButton
            onClick={
              adjusted_estimate
                ? this.handleStageEnd
                : this.handleNewEstimateSubmit
            }
            disabled={fetching}
            expand="full"
            className="ion-no-margin"
            color="success"
          >
            {fetching ? (
              <IonSpinner />
            ) : adjusted_estimate ? (
              'Next Stage'
            ) : (
              'Set Estimate'
            )}
          </IonButton>
        </IonFooter>
      </React.Fragment>
    );
  }
}

StageWork.propTypes = {
  nextStage: PropTypes.func.isRequired,
  updateStage: PropTypes.func.isRequired,
  stage: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired
};

export default (props) => {
  return (
    <Subscribe
      to={[props.stageContainer]}
      render={({ state }) => {
        const { timePassed } = state;
        return <StageWork {...props} timePassed={timePassed} />;
      }}
    />
  );
};
